import * as angular from "angular";
import * as _ from "lodash";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class FulfillmentAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService) {
  }

// ******************************
//        Public methods
// ******************************

  dispatchStepSuccess(enableView?: boolean) {
    const message = {
      body: 'FULFILLMENT_DISPATCH_STEP_SUCCESS'
    };
    const view = enableView ? 'View' : null;
    return this.bringozToastService.info(message, undefined, view);
  }

  dispatchStepError(error) {
    const message = {
      body: 'FULFILLMENT_DISPATCH_STEP_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getQuoteError(moreInfo?: string) {
    const message = {
      body: 'FULFILLMENT_QUOTE_ERROR',
      message: moreInfo,
      details: moreInfo ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  bulkDispatchSuccess() {
    const message = {
      body: 'FULFILLMENTS_BULK_DISPATCH_INITIATION_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  bulkDispatchError() {
    const message = {
      body: 'FULFILLMENTS_BULK_DISPATCH_INITIATION_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  stepsPriceUpdateSuccess() {
    const message = {
      body: 'FULFILLMENT_STEPS_PRICE_UPDATE_SUCCESS'
    }
    return this.bringozToastService.success(message)
  }

  stepsPriceUpdateError() {
    const message = {
      body: 'FULFILLMENT_STEPS_PRICE_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    }
    return this.bringozToastService.error(message)
  }

  exportSuccess() {
    const message = {
      body: 'FULFILLMENT_STEPS_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'FULFILLMENT_STEPS_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  dispatchStepRequiredError() {
    const message = {
      body: 'DISPATCH_STEP_FIELDS_REQUIRED',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  viewSettingsChangesSuccess() {
    const message = {
      body: 'FULFILLMENT_VIEW_SETTINGS_CHANGE_SUCCESS_DETAILS',
      details: 'FULFILLMENT_VIEW_SETTINGS_CHANGE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  splitStepPackagesSuccess() {
    const message = {
      body: 'MOVE_STEP_PACKAGES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  splitStepPackagesError() {
    const message = {
      body: 'MOVE_STEP_PACKAGES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // MANUAL HANDLED //
  manualHandledAttemptManySuccess() {
    const message = {
      body: 'FULFILLMENT_STEP_ATTEMPT_HANDLED_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  manualHandledAttemptSingleSuccess() {
    const message = {
      body: 'FULFILLMENT_STEP_ATTEMPT_HANDLED_SINGLE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  manualHandledAttemptManyError() {
    const message = {
      body: 'FULFILLMENT_STEP_ATTEMPT_HANDLED_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  manualHandledAttemptSingleError() {
    const message = {
      body: 'FULFILLMENT_STEP_ATTEMPT_HANDLED_SINGLE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }


  cancelAttemptManySuccess() {
    const message = {
      body: 'FULFILLMENT_STEP_ATTEMPT_CANCEL_MANY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  cancelAttemptSingleSuccess() {
    const message = {
      body: 'FULFILLMENT_STEP_ATTEMPT_CANCEL_SINGLE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  cancelAttemptManyError() {
    const message = {
      body: 'FULFILLMENT_STEP_ATTEMPT_CANCEL_MANY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  cancelAttemptSingleError() {
    const message = {
      body: 'FULFILLMENT_STEP_ATTEMPT_CANCEL_SINGLE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  cancelStepSuccess() {
    const message = {
      body: 'FULFILLMENT_STEP_CANCEL_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  cancelStepError() {
    const message = {
      body: 'FULFILLMENT_STEP_CANCEL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  cancelStepsSuccess() {
    const message = {
      body: 'FULFILLMENT_STEPS_CANCEL_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  cancelStepsError() {
    const message = {
      body: 'FULFILLMENT_STEPS_CANCEL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  forceCompleteLineError() {
    const message = {
      body: 'FULFILLMENT_LINE_CANCEL_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getGlobalSearchError() {
    const message = {
      body: 'GLOBAL_SEARCH_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  restoreFulfillmentSuccess() {
    const message = {
      body: 'RESTORE_FULFILLMENT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  restoreFulfillmentError() {
    const message = {
      body: 'RESTORE_FULFILLMENT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  bulkRestoreFulfillmentSuccess() {
    const message = {
      body: 'RESTORE_FULFILLMENTS_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  bulkRestoreFulfillmentError() {
    const message = {
      body: 'RESTORE_FULFILLMENTS_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  crossedMinTimeWindowRangeInfo() {
    const message = {
      body: 'DISPATCH_CROSSED_MIN_TIME_WINDOW_RANGE_INFO'
    };
    return this.bringozToastService.info(message)
  }

  crossedMaxTimeWindowRangeInfo() {
    const message = {
      body: 'DISPATCH_CROSSED_MAX_TIME_WINDOW_RANGE_INFO'
    };
    return this.bringozToastService.info(message)
  }


}

angular
  .module('bringoz.admin.fulfillment')
  .service('fulfillmentAlertsService', FulfillmentAlertsService);
